/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskMcpServerCountsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskMcpServerCountsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskMcpServerCountsSecurity = {
  option1?: GetRiskMcpServerCountsSecurityOption1 | undefined;
  option2?: GetRiskMcpServerCountsSecurityOption2 | undefined;
};

export type GetRiskMcpServerCountsRequest = {
  /**
   * Inclusive start of the window. Defaults to 7 days before to.
   */
  from?: Date | undefined;
  /**
   * Exclusive end of the window. Defaults to now.
   */
  to?: Date | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskMcpServerCountsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskMcpServerCountsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetRiskMcpServerCountsSecurityOption1$Outbound,
    GetRiskMcpServerCountsSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getRiskMcpServerCountsSecurityOption1ToJSON(
  getRiskMcpServerCountsSecurityOption1: GetRiskMcpServerCountsSecurityOption1,
): string {
  return JSON.stringify(
    GetRiskMcpServerCountsSecurityOption1$outboundSchema.parse(
      getRiskMcpServerCountsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskMcpServerCountsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskMcpServerCountsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetRiskMcpServerCountsSecurityOption2$Outbound,
    GetRiskMcpServerCountsSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getRiskMcpServerCountsSecurityOption2ToJSON(
  getRiskMcpServerCountsSecurityOption2: GetRiskMcpServerCountsSecurityOption2,
): string {
  return JSON.stringify(
    GetRiskMcpServerCountsSecurityOption2$outboundSchema.parse(
      getRiskMcpServerCountsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskMcpServerCountsSecurity$Outbound = {
  Option1?: GetRiskMcpServerCountsSecurityOption1$Outbound | undefined;
  Option2?: GetRiskMcpServerCountsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskMcpServerCountsSecurity$outboundSchema: z.ZodMiniType<
  GetRiskMcpServerCountsSecurity$Outbound,
  GetRiskMcpServerCountsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskMcpServerCountsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskMcpServerCountsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskMcpServerCountsSecurityToJSON(
  getRiskMcpServerCountsSecurity: GetRiskMcpServerCountsSecurity,
): string {
  return JSON.stringify(
    GetRiskMcpServerCountsSecurity$outboundSchema.parse(
      getRiskMcpServerCountsSecurity,
    ),
  );
}

/** @internal */
export type GetRiskMcpServerCountsRequest$Outbound = {
  from?: string | undefined;
  to?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskMcpServerCountsRequest$outboundSchema: z.ZodMiniType<
  GetRiskMcpServerCountsRequest$Outbound,
  GetRiskMcpServerCountsRequest
> = z.pipe(
  z.object({
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskMcpServerCountsRequestToJSON(
  getRiskMcpServerCountsRequest: GetRiskMcpServerCountsRequest,
): string {
  return JSON.stringify(
    GetRiskMcpServerCountsRequest$outboundSchema.parse(
      getRiskMcpServerCountsRequest,
    ),
  );
}
